import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config/config";
import axios from "axios";
import PaymentModal from "./PaymentModal";
import { FaCheckCircle } from "react-icons/fa";
import { useUser } from "../../../context/UserContext";

const PaymentDetailsComponent = () => {
  const { clientUser: user } = useUser();
  const [firstName, setFirstName] = useState(user?.firstName || "");
  const [lastName, setLastName] = useState(user?.lastName || "");
  const [email, setEmail] = useState(user?.email || "");
  const [areasData, setAreasData] = useState([
    { text: "Yes", isSelected: false },
    { text: "No", isSelected: false },
  ]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [hasAuthorizedPayment, setHasAuthorizedPayment] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();

  const fundingOptions = ["NDIS", "Home Care Package", "Other"];
  const paymentOptions = ["Credit/Debit card - ACH Direct Deposit"];
  const fundingSubOptions = ["Self-managed", "Plan-managed"];

  useEffect(() => {
    console.log("fsPayment user data:", user);
  }, [user]);

  useEffect(() => {
    if (
      user?.paymentDetailsUpdated &&
      !user.paymentDetails.usingGovernmentFunding &&
      user.paymentDetails.paymentIntentDetails.paymentType === "card" &&
      user.paymentDetails.paymentIntentDetails.hasAuthorizedPayment
    ) {
      const newAreasData = [...areasData];
      newAreasData[1].isSelected = true;
      setAreasData(newAreasData);
      setSelectedPaymentOption("Credit/Debit card - ACH Direct Deposit");
      setShowSuccessMessage(true);
      setHasAuthorizedPayment(
        user.paymentDetails.paymentIntentDetails.hasAuthorizedPayment
      );
    }
  }, [user]);

  const toggleSelection = (index) => {
    const newData = [...areasData];
    newData.forEach((item) => (item.isSelected = false));
    newData[index].isSelected = !newData[index].isSelected;
    setAreasData(newData);
  };

  const handleFundingOptionClick = (option) => {
    setSelectedOption(option);
  };

  const handlePaymentOptionClick = (option) => {
    setSelectedPaymentOption(option);
    if (option === "Credit/Debit card - ACH Direct Deposit") {
      setShowCardDetails(true);
    } else {
      setShowCardDetails(false);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const requestBody = {
        email: email,
        firstname: firstName,
        lastname: lastName,
      };
      const { data } = await axios.post(
        `${config.API_BASE_URL}/v1/stripe/customer-and-setupintent`,
        requestBody
      );

      const clientSecret = data.clientSecret;
      console.log("Client Secret:", clientSecret);
      setClientSecret(clientSecret);
      setModalVisible(true);
      navigate(
        "/account/fs-dashboard/my-account/payment-details/payment-setup"
      );
    } catch (error) {
      setMessage(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="fs-payment-component-container">
      <div className="fs-payment-above-div1">
        <h2>Payment details</h2>
        <p>Are you using government funding to pay for this support?</p>
      </div>

      <div className="area-buttons-container">
        {areasData.map((area, index) => (
          <button
            key={area.text}
            className={`horizontal-button ${area.isSelected ? "selected" : ""}`}
            onClick={() => toggleSelection(index)}
          >
            {area.isSelected && <div className="fs-payment-checkmark">✓</div>}
            <div className="button-text">{area.text}</div>
          </button>
        ))}
      </div>

      {areasData[0].isSelected && (
        <div className="funding-options-container">
          <div className="funding-buttons-container">
            {fundingOptions.map((option) => (
              <button
                key={option}
                className={`funding-option-button ${
                  selectedOption === option ? "selected" : ""
                }`}
                onClick={() => handleFundingOptionClick(option)}
              >
                {selectedOption === option && (
                  <div className="fs-payment-checkmark">✓</div>
                )}
                {option}
              </button>
            ))}
          </div>
        </div>
      )}

      {areasData[1].isSelected && (
        <div className="payment-options-container">
          <div className="payment-buttons-container">
            {paymentOptions.map((option) => (
              <button
                key={option}
                className={`payment-option-button ${
                  selectedPaymentOption === option ? "selected" : ""
                }`}
                onClick={() => handlePaymentOptionClick(option)}
              >
                {selectedPaymentOption === option && (
                  <div className="fs-payment-checkmark">✓</div>
                )}
                {option}
              </button>
            ))}
          </div>
        </div>
      )}

      {showCardDetails && !showSuccessMessage && (
        <div className="fs-payment-customer-details">
          <form onSubmit={handleFormSubmit}>
            <h2>Billing details</h2>
            <div className="relationship-detail">
              <div className="fs-payment-detail">
                <h3>
                  First Name <span className="required-indicator">*</span>
                </h3>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="relationship-detail">
              <div className="fs-payment-detail">
                <h3>
                  Last Name <span className="required-indicator">*</span>
                </h3>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="relationship-detail">
              <div className="fs-payment-detail">
                <h3>
                  Email <span className="required-indicator">*</span>
                </h3>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <button type="submit">Confirm details</button>
          </form>
        </div>
      )}

      {showSuccessMessage && (
        <div className="fs-payment-success-details">
          <h4>Payment Authorization and Card Details</h4>
          <p>
            OSH will charge your credit card within 24 - 48 hours of support
            hours upon your approval.
          </p>
          <div className="fs-payment-checkbox-container">
            <input
              type="checkbox"
              checked={hasAuthorizedPayment}
              className="container-checkbox"
              readOnly
            />
            <label className="checkbox-container-label">
              I authorize OSH to charge my credit card for approved support
              worker bookings including the applicable platform fee incurred
              through the OSH Platform.
            </label>
          </div>
          <div className="fs-added-payment-success">
            <FaCheckCircle className="fs-payment-success-icon" /> Card details
            added successfully to Stripe wallet.
          </div>
          <div className="fs-payment-save">
            <button>Update card details</button>
          </div>
        </div>
      )}

      {message && <div>{message}</div>}

      <PaymentModal
        show={modalVisible}
        handleClose={closeModal}
        clientSecret={clientSecret}
        firstName={user?.firstName || ""}
        lastName={user?.lastName || ""}
        email={user?.email || ""}
        user={user}
      />
    </div>
  );
};

export default PaymentDetailsComponent;
